import Aboutone from '../components/About/Aboutone'
import AboutSecond from '../components/About/AboutSecond'
import Aboutservice from '../components/About/Aboutservice'
import Projectwork from '../components/About/Projectwork'
import ThreeSteps from '../components/About/ThreeSteps'
import Work from '../components/About/Work'
import Contactfooter from '../components/Contactfooter'
import Footer from '../components/Footer/Footer'
import Navbar from '../components/Navbar/Navbar'

const Aboutpage = () => {
  return (
    <div>
        <Navbar/>
        <AboutSecond/>

        <ThreeSteps/>
     
        

        <Contactfooter/>
       

        <Footer/>
    </div>
  )
}

export default Aboutpage